import {Component} from '@angular/core';

@Component({
  selector: 'app-import-data',
  templateUrl: './import-data.component.html',
})
export class ImportDataComponent {

}
